import { z } from 'zod';

import { AbstractMeasurement } from './AbstractMeasurement';

const units = ['A²•s'] as const;

const validator = AbstractMeasurement.value
    .extend({
        unit: z.literal('A²•s').default('A²•s'),
    })
    .default({});

export const i2tRating = {
    validator,
    units,
};

export type i2tRating = z.infer<typeof validator>;
